import { useContext, createContext } from 'react';
import dispatchGTMEvent from './dispatchGTMEvent';
var trackingContext = createContext({
    gtmId: '',
    auth: '',
    preview: '',
});
export var TrackingProvider = trackingContext.Provider;
export var useTracking = function () {
    var _a = useContext(trackingContext), auth = _a.auth, gtmId = _a.gtmId, preview = _a.preview, _b = _a.dataLayerName, dataLayerName = _b === void 0 ? 'dataLayer' : _b;
    var gtmAuth = auth ? "&gtm_auth=" + auth : '';
    var gtmPreview = preview ? "&gtm_preview=" + preview : '';
    if (typeof window !== 'undefined' && dataLayerName && gtmId !== '' && !window[dataLayerName]) {
        // load GTM if dataLayer doesn't exist yet
        window[dataLayerName] = [];
        var script = document.createElement('script');
        script.setAttribute('data-testid', 'gtm-script');
        script.innerHTML = "!function(t,e,n,o,a){t[o]=t[o]||[],t[o].push({\"gtm.start\":(new Date).getTime(),event:\"gtm.js\"});var d=e.getElementsByTagName(n)[0],m=e.createElement(n);m.async=!0,m.src=\"https://www.googletagmanager.com/gtm.js?id=" + gtmId + "&l=\"+o+\"" + gtmAuth + gtmPreview + "&gtm_cookies_win=x\",m.onload=function(){m.onload=null,window.gmtLoaded=!0,window.gmtBlocked=!1;var t=document.createEvent(\"Event\");t.initEvent(\"gtmLoaded\",!1,!0),e.dispatchEvent(t)},m.onerror=function(){m.onerror=null,window.gmtLoaded=!0,window.gmtBlocked=!0;var t=document.createEvent(\"Event\");t.initEvent(\"gtmLoaded\",!1,!0),e.dispatchEvent(t)},d.parentNode.insertBefore(m,d)}(window,document,\"script\",\"" + dataLayerName + "\");";
        document.head.insertBefore(script, document.head.firstElementChild);
    }
    return function (event) { return dispatchGTMEvent(event, dataLayerName); };
};
export default useTracking;
//# sourceMappingURL=index.js.map